
const Loader = ({ isDataLoading }) => {

    return (
        isDataLoading && <div className="loader">
            <div className="spinner"></div>
        </div>

    )
}

export default Loader